// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"c281cb16","563":"1038622b"}[chunkId] + ".chunk.js";
};